export const translations = {
  bg: {
    nav: {
      about: "Информация за мен",
      musicStyle: "Стил музика",
      experience: "Професионален опит",
      whyChoose: "Защо да изберете DJ NKEY",
      gallery: "Галерия",
      contact: "Контакт"
    },

    hero: {
      welcome: "Welcome to the official website of",
      tagline: "Професионален DJ за вашето незабравимо събитие",
      bookNow: "Резервирай Сега",
      upcomingEvents: "Предстоящи Събития"
    },

    about: {
      title: "Кой е DJ NKEY?",
      bio1: "Здравейте! Аз съм Николай Нанчев – диджей и водещ на събития...",
      bio2: "С повече от 10 години опит зад пулта...",
      bio3: "Зад гърба си имам участия...",
      bio4: "За мен всяко събитие има собствена енергия.",
      card1Title: "Опит",
      card1Desc: "Над 10 години опит зад пулта и стотици участия",
      card2Title: "DJ Сетове",
      card2Desc: "DJ сетове на различни локации и работа с артисти",
      card3Title: "Частни събития",
      card3Desc: "Корпоративни партита, абитуриентски балове, юбилеи и сватби"
    },

    musicStyle: {
      title: "Стил музика",
      subtitle: "Разнообразие от музикални стилове за всеки вкус и събитие",
      discoverMusic: "Открийте Моята Музика",
      discoverDesc: "Слушайте моите миксове и почувствайте енергията на музиката",
      listenSoundcloud: "Слушай в SoundCloud"
    },

    experience: {
      title: "Професионален опит",
      subtitle: "Изпълнения в топ заведения в София, България и чужбина",
      years: "Години Опит",
      events: "Събития",
      clubs: "Клуба",
      clients: "Доволни Клиенти",
      skillsTitle: "Техническо осигуряване и умения",
      skill1: "DJ оборудване",
      skill2: "Светлинни и пушек ефекти",
      skill3: "Тематичен и хармоничен микс",
      skill4: "Водене на събития с микрофон"
    },

    whyChoose: {
      title: "Защо да изберете DJ NKEY",
      subtitle: "",

      reason1: "Над десет години професионален опит",
      reason1Desc: "Богат опит в индустрията и стотици участия",

      reason2: "Изпълнения в най-добрите заведения",
      reason2Desc: "Клубове, барове, ресторанти и зали за събития",

      reason3: "Опит в озвучаването",
      reason3Desc: "Колаборации и съвместни участия с популярни изпълнители",

      testimonialQuote: `Николай беше диджей на партито за моя рожден ден. Със сигурност мога да кажа, че благодарение на него, купонът беше на "макс" и настроението – страхотно!
Не го познавах предварително, но всички притеснения изчезнаха още при първия ни разговор. Ники старателно проучва музикалните предпочитания на клиента, прави допълнителни предложения и може да реагира бързо на момента.
С него се работи лесно.

Препоръчвам ви го!`,

      testimonialAuthor: "Ivayla Tasseva",
      testimonialDate: "26.11.2023 г.",

      ctaTitle: "Готови ли сте за незабравимо събитие?",
      ctaSubtitle: "Свържете се с мен днес и нека направим вашето събитие специално",
      ctaButton: "Резервирай Сега"
    },

    gallery: {
      title: "Галерия",
      subtitle: "Моменти от моите изпълнения",
      close: "Затвори"
    },

    contact: {
      title: "Свържете Се",
      subtitle: "Имате въпроси или искате да резервирате? Свържете се с мен!",
      email: "Имейл",
      phone: "Телефон",
      viber: "Viber",
      formTitle: "Изпратете Запитване",
      name: "Име",
      namePlaceholder: "Вашето име",
      emailLabel: "Имейл",
      emailPlaceholder: "your@email.com",
      phoneLabel: "Телефон",
      phonePlaceholder: "+359 888 123 456",
      message: "Съобщение",
      messagePlaceholder: "Разкажете ми за вашето събитие...",
      submit: "Изпрати Запитване",
      successTitle: "Успешно изпратено!",
      successMessage: "Вашето запитване беше получено. Ще се свържем с вас скоро."
    },

    footer: {
      description: "Професионален DJ за всяко ваше събитие.",
      quickLinks: "Бързи Връзки",
      followMe: "Последвайте Ме",
      copyright: "Всички права запазени."
    },

    musicPlayer: {
      play: "Пусни музика",
      pause: "Спри музика",
      mute: "Заглуши",
      unmute: "Включи звук",
      hide: "Скрий"
    }
  },

  en: {
    nav: {
      about: "About Me",
      musicStyle: "Music Style",
      experience: "Professional Experience",
      whyChoose: "Why Choose DJ NKEY",
      gallery: "Gallery",
      contact: "Contact"
    },

    hero: {
      welcome: "Welcome to the official website of",
      tagline: "Professional DJ for your unforgettable event",
      bookNow: "Book Now",
      upcomingEvents: "Upcoming Events"
    },

    about: {
      title: "Who is DJ NKEY?",
      bio1: "Hello! I'm Nikolay Nanchev – DJ and event host...",
      bio2: "With over 10 years of experience behind the decks...",
      bio3: "I have performed in clubs, bars and private events...",
      bio4: "Every event has its own energy.",
      card1Title: "Experience",
      card1Desc: "Over 10 years of professional experience.",
      card2Title: "DJ Sets",
      card2Desc: "Professional DJ sets at various locations.",
      card3Title: "Private Events",
      card3Desc: "Corporate parties, proms, weddings and more."
    },

    musicStyle: {
      title: "Music Style",
      subtitle: "Variety of musical styles for every taste and event",
      discoverMusic: "Discover My Music",
      discoverDesc: "Listen to my mixes and feel the energy",
      listenSoundcloud: "Listen on SoundCloud"
    },

    experience: {
      title: "Professional Experience",
      subtitle: "Performances in top venues",
      years: "Years Experience",
      events: "Events",
      clubs: "Clubs",
      clients: "Happy Clients",
      skillsTitle: "Technical Equipment & Skills",
      skill1: "DJ Equipment",
      skill2: "Light & Smoke Effects",
      skill3: "Thematic & Harmonic Mix",
      skill4: "Event Hosting with Microphone"
    },

    whyChoose: {
      title: "Why Choose DJ NKEY",
      subtitle: "Your event deserves the best",

      reason1: "Over 10 years of professional experience",
      reason1Desc: "Rich experience in the industry and hundreds of events",

      reason2: "Performances in top venues",
      reason2Desc: "Clubs, bars, restaurants and event halls",

      reason3: "Sound engineering experience",
      reason3Desc: "Collaborations and joint performances with popular artists",

      testimonialQuote: `Nikolay was the DJ at my birthday party. I can definitely say that thanks to him, the party was at its "max" and the mood was great!
I didn't know him beforehand, but all my worries disappeared during our first conversation. Niki carefully studies the client's musical preferences, makes additional suggestions and can react quickly to the moment.
He is easy to work with.

I recommend him to you!`,

      testimonialAuthor: "Ivayla Tasseva",
      testimonialDate: "26.11.2023",

      ctaTitle: "Ready for an unforgettable event?",
      ctaSubtitle: "Contact me today and let's make your event special",
      ctaButton: "Book Now"
    },

    gallery: {
      title: "Gallery",
      subtitle: "Moments from my performances",
      close: "Close"
    },

    contact: {
      title: "Get In Touch",
      subtitle: "Have questions or want to book?",
      email: "Email",
      phone: "Phone",
      viber: "Viber",
      formTitle: "Send Inquiry",
      name: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      phoneLabel: "Phone",
      phonePlaceholder: "+359 888 123 456",
      message: "Message",
      messagePlaceholder: "Tell me about your event...",
      submit: "Send Inquiry",
      successTitle: "Successfully sent!",
      successMessage: "Your inquiry has been received."
    },

    footer: {
      description: "Professional DJ for every event.",
      quickLinks: "Quick Links",
      followMe: "Follow Me",
      copyright: "All rights reserved."
    },

    musicPlayer: {
      play: "Play music",
      pause: "Pause music",
      mute: "Mute",
      unmute: "Unmute",
      hide: "Hide"
    }
  }
};
